import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { AddPageMenu } from '../addPageMenu/addPageMenu';
import { DataHubService } from 'src/core/services/datahub';
import { ClickContentAddPageOptionsSchema } from 'src/core/services/datahub/schemas/moduleList/clickContentAddPageActionsSchema';
import { DropdownControl } from 'src/shared/components/dropdown/dropdownControl';
import { Icon } from 'src/shared/components/icon';
const Content = ({ isOpen, moduleId, children }) => {
    const { t } = useTranslation();
    function handleAddPage() {
        DataHubService.sendEvent({
            schema: new ClickContentAddPageOptionsSchema({
                componentName: 'BOTTOM_ADD_BUTTON'
            })
        });
    }
    return (_jsx("div", { "data-testid": "content", className: clsx(`bg-gray-100 rounded-lg shadow-md grid p-0 transition-[grid-template-rows] duration-300 ease-in-out`, {
            'grid-rows-[1fr]': isOpen,
            'grid-rows-[0fr]': !isOpen
        }), children: _jsx("div", { className: clsx({ 'overflow-hidden': !isOpen }), children: _jsxs("div", { className: "m-2 flex flex-col gap-2 rounded-extralarge border-radius bg-neutral-100 p-2 md:m-4 md:p-4", children: [children, _jsx(AddPageMenu, { position: "start", moduleId: moduleId, controls: _jsx(DropdownControl, { variation: "secondary", openIndicator: false, onClick: handleAddPage, className: "mt-2 max-w-min", icon: _jsx(Icon, { icon: faPlus }), openClassName: "!bg-primary-100 !border-primary-700 !color-primary-700", children: t('general.add') }) })] }) }) }));
};
export default Content;
